import * as React from 'react';
import Box from '@mui/material/Box';
import { useRecoilState } from 'recoil';

import { getUniqueId } from '../../../helpers/helper.functions';

import './index.scss';

import ViewBulletin from './viewBulletin';
import BulletinList from './list';
import { parentConfigState } from '../../../state/reducerAtoms/parent.atom';
import { hasAccess } from '../../../helpers/auth.helper';
import AccessDeniedScreen from '../../../components/access/accessDenied';


export default function BulletinSection() {
    const [configState, setConfigState] = useRecoilState(parentConfigState);
    const canAccess = hasAccess('bulletin');

    /**
     * Gets the content to display based on the current selection
     */
    const getSelectedContent = () => {
        const selectedItem = configState?.bulletinSection?.selectedPageView || 'bulletin-list';
        let contentSelected = <></>
        switch (selectedItem) {
            case 'bulletin-list':
                contentSelected = <BulletinList
                    key={`${getUniqueId()}-bulletin-key`}
                    onClose={() => {
                        modifyConfigState({ selectedBulletinId: "", selectedPageView: "bulletin-list" });
                    }}
                    onViewBulletin={(id) => {
                        modifyConfigState({ selectedPageView: "bulletin-view", selectedBulletinId: id });
                    }}
                />;
                break;
            case 'bulletin-view':
                contentSelected = configState?.bulletinSection?.selectedBulletinId ? <ViewBulletin
                    key={`${getUniqueId(configState?.bulletinSection?.selectedBulletinId)}-bulletin-key-${configState?.bulletinSection?.selectedBulletinId}`}
                    id={configState?.bulletinSection?.selectedBulletinId}
                    onClose={() => {
                        modifyConfigState({ selectedBulletinId: "", selectedPageView: "bulletin-list" });
                    }}
                /> : <span>not found</span>;
                break;
            default:
                contentSelected = <span>Not found</span>;
                break;
        }
        if(!canAccess) {
            contentSelected = <AccessDeniedScreen/>

        }
        return contentSelected;
    }

    /**
    * Invokes when a state modified
    * @returns Fun
    */
    const modifyConfigState = (modifiedObj = {}) => setConfigState((prv) => ({ ...prv, ...{ bulletinSection: { ...prv.bulletinSection, ...modifiedObj } } }));

    return (
        <>
            <Box component="div" className='bulletin-main-wrp f-wrp' sx={{ flexGrow: 1, p: 3, }}>
                {getSelectedContent()}
            </Box>
        </>
    );
}